module.exports = __webpack_public_path__ + "01_mid_yellow.7d4a16f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/01_mid_yellow.png
// module id = mjmc
// module chunks = 0